import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getToken } from "../../routes/cookies";

const getApiBaseUrl = () => {
  if (typeof window !== "undefined") {
    const hostname = window.location.hostname;
    if (hostname !== "localhost" && hostname !== "127.0.0.1" && !hostname.startsWith("192.168.")) {
      return "https://api.bagdamahasabha.org/api/admin";
    }
  }
  return process.env.REACT_APP_API_BASE_URL || "https://api.bagdamahasabha.org/api/admin";
};

export const baseApi = createApi({
  reducerPath: "baseApi",

  baseQuery: fetchBaseQuery({
    baseUrl: getApiBaseUrl(),

    prepareHeaders: (headers, { body }) => {
      const token = getToken();

      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }

      if (body instanceof FormData) {
        headers.delete("Content-Type");
      }

      return headers;
    },
  }),

  tagTypes: ["Category","SubCategory","State","City","Amenities","Testimonials","Product","Location","Blog","subCategories","Gotra","NanihalGotra","Kuldevi","occupation","education","webSite","banner","event","news","Waad","Gaon","SETTINGS"],

  endpoints: () => ({}),
});